<p class="title" [class.text-bold]="boldText">{{pageTitle}}</p>
